import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import AhPwdlessCommonsUtility from "utilities/login/ah-pwdless-common-utility/1.0.0/js/ah-pwdless-common-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import ahInputValidationUtility from "utilities/login/ah-input-validation-utility/1.0.0/js/ah-input-validation-utility";
import ahModalUtility from "utilities/login/ah-modal-utility/2.0.0/js/ah-modal-utility";
import ahPubsubUtility from "utilities/login/ah-pubsub-utility/2.0.0/js/ah-pubsub-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import spartaTemplates from "modules/login/ah-di-module/2.0.1/js/templates";
import "css!modules/login/ah-di-module/2.0.1/css/ah-di-module.scss.css";

export default class ahDiController {

    constructor(parentModule) {
        this.parentModule = parentModule;
        this._model = parentModule.model;
        this._view = parentModule.view;

        const self = this;
        this.bindThisContext([
              ' _defineVars',
              '_bindEventHandlers',
              '_listen',
              '_subscribeEvents',
                'initialize'
            ],
            self, '');
    }
    bindThisContext(methods, context, suffix = 'Scoped') {
        const self = context;

        if (methods && $.isArray(methods) && methods.length > 0) {
            $(methods).each((index, method) => {
                if (self[method]) {
                    self[method + suffix] = self[method].bind(context);
                } else {
                    console.log(`Method: ${method} Not found in current context.`);
                }
            });
        }
    }

    _defineVars() {
      this.templates ={};
      this.$moduleContext = $(this.parentModule.view.settings.target);
      this.$moduleContext.spartaInputs();

      const _view = this.parentModule.view;
      this.$moduleContext = $(_view.settings.target);
      return this;
    }

    _bindEventHandlers() {
        return this;
    }

    _listen() {

        return this;
    }

    _subscribeEvents() {
        const main = this.parentModule;
        const controller = this.parentModule.controller;
        const parent = this.parentModule;
        const self= this;
        const widgetConfigData = {
            userData: "data",
        };

              main.Events.sub(cawEventsMasterUtility.EVENTS.INTERNAL.CAW_CLIENTPARAMS, (e) => {
            main.Store.addData('widgetConfigData', widgetConfigData);
            controller.emit({ context: 'update-widget-configdata', data: widgetConfigData });
        });
        return this;
    }


    initialize() {
        this._defineVars()
            ._bindEventHandlers()
            ._subscribeEvents()
            ._listen();
    }
}
